module.exports = __webpack_public_path__ + "1b349d7821eee5175857c7b32195974c.png";